import { FieldRenderProps, FieldWrapper } from "@progress/kendo-react-form";
import { FunctionComponent, useEffect, useState } from "react";
import { Api } from "../../../redux/api/BaseApi";
import { Label } from "@progress/kendo-react-labels";
import { MultiSelect, MultiSelectFilterChangeEvent } from "@progress/kendo-react-dropdowns";
import { filterBy } from "@progress/kendo-data-query";
import { UserApi } from '../../../redux/api/UserApi';

const AssignedStaff: FunctionComponent<FieldRenderProps> = props => {
    const {
        label,
        id,
        valid,
        disabled,
        optional,
        teamId,
        staff,
        showMe,
        onChange,
    } = props;
    //const { ticket } = useReduxSelector(state => state.ticketDetails);
    const { data: userProfile } = Api.useGetUserProfileQuery();
    const assignedStaff = staff?.map(ass => { return { Full_Name: ass?.Contact_Name, ID: ass.Contact_Id } });
    let { data: staffList, isLoading: staffLoading } = UserApi.useGetStaffQuery({ teamId: teamId, includeQueues: true, includeStaffPlusForCompanyId: 0 });


    const [staffFiltered, setStaff] = useState([])

    const onFilter = (event: MultiSelectFilterChangeEvent) => {
        console.log('Filter', event);
        setStaff(filterBy(staffList?.slice(), event.filter));
    }

    useEffect(() => {
        console.log('Team chnaged', teamId, staffList?.length)

        if (showMe)
            staffList = staffList?.map(s => s.ID === userProfile?.Id ? { ...s, Full_Name: '<Me>' } : s);

        setStaff(staffList)
    }, [staffList]);
    return (
        <FieldWrapper >
            <Label
                editorId={id}
                editorValid={valid}
                editorDisabled={disabled}
                optional={optional}>
                {label}
            </Label>
            {/* {JSON.stringify(assignedStaff)} */}
            <div className={"k-form-field-wrap"}>
                <MultiSelect filterable={true} popupSettings={{ className: 'z500' }} onFilterChange={onFilter} onChange={onChange} data={staffFiltered} value={assignedStaff} dataItemKey="ID" textField="Full_Name" loading={staffLoading} />
            </div>
        </FieldWrapper>
    )
}

export default AssignedStaff;